module.exports = __webpack_public_path__ + "img/hr-sand-rock-big-05.2de95100.png";